/** Build-time config (Vite inlines VITE_*). Production defaults, so a bare build talks to production. */
const env = import.meta.env

export const config = {
  apiUrl: env.VITE_API_URL || 'https://api.cpg.computer',
  kindeDomain: env.VITE_KINDE_DOMAIN || 'https://auth.cpg.computer',
  kindeClientId: env.VITE_KINDE_CLIENT_ID || '6c8e00a60c8146c0af48cbdca70e8a99',
  kindeAudience: env.VITE_KINDE_AUDIENCE || 'https://api.cpg.computer/', // Kinde registered it with the trailing slash
  mock: env.VITE_MOCK === '1',
}

/**
 * The onboarding demo (admin → Pitch → Demo): the founder app on the in-browser mock, under this path, on example
 * data only. It never signs in and never calls the API, so it is safe to reach without signing in.
 */
export const DEMO_BASE = '/demo/onboarding'
export const isDemo = (): boolean => location.pathname === DEMO_BASE || location.pathname.startsWith(`${DEMO_BASE}/`)

/**
 * The onboarding demo runs only inside the admin's Pitch → Demo frame: this app's own origin, with the parent page on
 * /pitch (which only a signed-in admin reaches). Opened any other way it shows where it opens. A visibility gate:
 * the demo holds example data only.
 */
export function framedByAdmin(): boolean {
  try {
    return window.top !== window.self && window.top!.location.origin === location.origin && window.top!.location.pathname.startsWith('/pitch')
  } catch {
    return false
  }
}

export const redirectUri = () => `${location.origin}/callback`
export const logoutUri = () => `${location.origin}/`
